import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import LeftSidebar from './components/leftSidebar';
import Header from './components/header';
import RightSidebar from './components/rightSidebar';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { AuthProvider } from 'components/AuthContext';
import { store, persistor } from './redux/store';
import FooterNav from 'components/footerNav';
import { NotificationContainer } from 'react-notifications';

const MainLayout = () => {
  const [rightMenu, setRightMenu] = useState(false);
  const [leftMenu, setLeftMenu] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const location = useLocation();
  const hideLeftSidebarRoutes = ['/', '/home'];
  const showRightSidebarRoutes = [
    /^\/event\/[^/]+\/[^/]+$/,
    // /^\/event\/[^/]+$/,
    // /^\/game\/[^/]+$/,
    // '/ipl',
    '/icc2025',
    '/inplay'
  ];
  const shouldHideLeftSidebar = hideLeftSidebarRoutes.includes(location.pathname);
  const shouldShowRightSidebar = showRightSidebarRoutes.some(route =>
    typeof route === 'string' ? route === location.pathname : route.test(location.pathname)
  );
  const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);

  const shouldShowSidebars = isAuthenticated && userdata?.user_type === 'User';
  const shouldShowLeftSidebar =
    (isAuthenticated && userdata?.user_type === 'User') ||
    (!isAuthenticated &&
      location.pathname !== '/' &&
      location.pathname !== '/home');
  return (
    <div className='h-screen overflow-hidden'>
      <div className="grid grid-cols-12">
        <div className='col-span-12 h-auto lg:h-[143px]'>
          <Header rightMenu={rightMenu} setRightMenu={setRightMenu} leftMenu={leftMenu} setLeftMenu={setLeftMenu} isLoginModalOpen={isLoginModalOpen} setIsLoginModalOpen={setIsLoginModalOpen} />
        </div>
        <div className={`col-span-12 flex ${(!isAuthenticated || userdata?.user_type === 'User') ? 'h-[calc(100vh-200px)]' : 'h-[calc(100vh-10vh)]'}  lg:h-[calc(100vh-143px)] overflow-auto [scrollbar-width:none]`}>
          {shouldShowLeftSidebar && (
            <div className='hidden lg:block min-w-[15%]' id="sidebar">
              <LeftSidebar setLeftMenu={setLeftMenu} />
            </div>
          )}
          <div className={`w-full lg:pb-[10px] ${shouldShowRightSidebar ? userdata?.user_type === 'User' ? 'lg:max-w-[60%] lg:px-[6px]' : 'lg:max-w-[75%] lg:px-[6px]' : ''} flex overflow-y-auto overflow-x-hidden [scrollbar-width:none]`}>
            <App />
          </div>
          {shouldShowRightSidebar && (
            <div className='hidden lg:block right-sidebar'>
              <RightSidebar />
            </div>
          )}
        </div>
        <div className='col-span-12 lg:hidden'>
          {/* {userdata?.user_type !== 'Super Admin' &&
            <FooterNav rightMenu={rightMenu} setRightMenu={setRightMenu} leftMenu={leftMenu} setLeftMenu={setLeftMenu} isLoginModalOpen={isLoginModalOpen} setIsLoginModalOpen={setIsLoginModalOpen} />
          } */}
          {(!userdata || userdata?.user_type == 'User') &&
            <FooterNav rightMenu={rightMenu} setRightMenu={setRightMenu} leftMenu={leftMenu} setLeftMenu={setLeftMenu} isLoginModalOpen={isLoginModalOpen} setIsLoginModalOpen={setIsLoginModalOpen} />
          }
        </div>
      </div>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider>
        <BrowserRouter>
          <NotificationContainer />
          <MainLayout />
        </BrowserRouter>
      </AuthProvider>
    </PersistGate>
  </Provider>
);

reportWebVitals();